import { render, staticRenderFns } from "./ConfiguracaoCiclo.vue?vue&type=template&id=72c339d6&scoped=true"
import script from "./ConfiguracaoCiclo.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoCiclo.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoCiclo.vue?vue&type=style&index=0&id=72c339d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c339d6",
  null
  
)

export default component.exports